// src/components/HeroBackground.jsx
import React from "react";

export default function HeroBackground({
  image = "/stock-creatives/running1.png",
  className = "",
}) {
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none fixed inset-0 z-0 w-[100vw] bg-center bg-cover ${className}`}
      style={{
        // modern viewport units + iOS safe area fill
        height: "100dvh",
        minHeight: "100lvh",
        backgroundImage: `url(${image})`,
        backgroundAttachment: "scroll",
        WebkitOverflowScrolling: "touch",
        WebkitTransform: "translateZ(0)",
      }}
    />
  );
}
